import React, { useEffect, useState } from 'react'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import Functions from '../../../../setup/utilities/Functions'
import SupplierToolbar from './components/SupplierToolbar'
import SupplierListing from './components/SupplierListing'

const SupplierWrapper: React.FC = () => {
  const intl = useIntl()
  const teamBreadCrumbs: Array<PageLink> = [
    {
      title: 'Home',
      path: '',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({ id: 'accounting.supplier.menu' }),
      path: '',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  const [supplier, setSupplier] = useState<ISupplier|undefined|null>(null)
  const [action, setAction] = useState<string>('')
  const [show, setShow] = React.useState(false)
  const handleClose = async (isSubmit: boolean) => {
    if (!isSubmit) {
      const isConfirmed = await Functions.sweetAlert(
        '<span class="mt-5">' + intl.formatMessage({ id: 'action.message' }) + '</span>',
        'warning',
        true,
        intl.formatMessage({ id: 'action.cancel' }),
        intl.formatMessage({ id: 'action.return' }),
        'btn btn-primary mt-10 mb-10',
        'btn btn-active-light mt-10 mb-10',
      )
      if (isConfirmed) {
        ''
        setShow(false)
      }
    } else {
      setShow(false)
    }
  }
  const handleShow = (supplier: ISupplier|undefined|null, action: string) => {
    setSupplier(supplier)
    setAction(action)
    setShow(true)
  }

  useEffect(() => {}, [supplier])
  return (
    <>
      <PageTitle breadcrumbs={teamBreadCrumbs} pageTitle={intl.formatMessage({ id: 'accounting.supplier.list' })}>
        <SupplierToolbar handleShow={handleShow}/>
      </PageTitle>
      <SupplierListing show={show} handleShow={handleShow} handleClose={handleClose} supplierSelected={supplier} action={action}/>
    </>
  )
}

export default SupplierWrapper
